import React, { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  numberWithCommas,
  RupeesToPaise,
} from "../../../../../utility/commaSeperator";
import { RUPEE_SYMBOL } from "../../../../../utility/Constants";
import { dateConvert } from "../../../../../utility/dateModifier";
import {
  beneficiaryTransactionHeader,
  CustomerTransactionHeader,
} from "../../../../../utility/TableHeaders";
import { CustomModal1 } from "../../../../components/customModal/CustomModal";
import CustomTable from "../../../../components/customTable/CustomTable";
import CustomViewModal from "../../../../components/CustomViewModal";
import { SUCCESS } from "../../../../resources/constantsManager";

function BeneficiaryTransaction({ details }) {
  const [openFilter, setOpenFilter] = useState(false);
  const [dateRange, setDateRange] = useState("");
  const [utr, setUtr] = useState("");
  const [van, setVan] = useState("");
  const [viewMoreModal, setShowViewMoreModal] = useState(false);
  const [data, setData] = useState("");
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [viewMoreData, setViewMoreData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [offset, setOffset] = useState(0);
  const getAllTransactions = (accountNumber) => {
    ApiRequestPost.beneficiaryTransactionHistory({
      accountNumber,
    })
      .then((response) => {
        if (response?.status === SUCCESS) {
          setData(response?.data?.content);
          setTotalElements(response?.data?.totalElements ?? 0);
          setTotalPages(response?.data?.totalPages ?? 0);
        } else {
          setData([]);
          setTotalElements(0);
          setTotalPages(0);
        }
      })
      .catch((erro) => {});
  };

  useEffect(() => {
    getAllTransactions(details?.accountNumber);
  }, [details]);
  return (
    <div style={{}}>
      <CustomTable
        tableStyle={{
          height: 320,
        }}
        headers={beneficiaryTransactionHeader}
        totalElements={totalElements}
        data={data}
        viewMore={(data) => {
          setShowViewMoreModal(true);
          setViewMoreData(data);
        }}
        totalPages={totalPages}
        handlePaginate={(page) => {
          setOffset(page);
          // getVanTransactionHistory(page, 10, dateRange, utr, van);
        }}
        offset={offset}
        isFilterApplied={isFilterApplied}
      />

      {viewMoreModal && (
        <CustomModal1
          open={viewMoreModal}
          onClose={() => setShowViewMoreModal(false)}
          viewMoreStyle={{
            justifyContent: "flex-end",
          }}
        >
          {" "}
          <CustomViewModal
            data={{
              "Date & Time": dateConvert(viewMoreData?.createdDate),
              "UTR:": viewMoreData?.gatewayReferenceId,
              "VPA:": viewMoreData?.customerPaymentDetails?.paymentId,
              "Transaction Type:": viewMoreData?.debit ? "Debit" : "Credit",
              "Amount:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.amount)),
              "Status:": viewMoreData?.status,
              "Fees:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.commission)),
              "Tax:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.tax)),
              // "beneficiary_account_no:": viewMoreData?.beneAccountNo,
              // "beneficiary_account_ifsc:": viewMoreData?.beneAccountIfsc,
              // "beneficiary_full_name:": viewMoreData?.beneFullName,
              "transfer_type:": "UPI",
              "transfer_unique_no:": viewMoreData?.gatewayReferenceId,
              "transfer_timestamp:": dateConvert(
                viewMoreData?.transactionTimestamp
              ),
              "transfer_ccy:": "INR",
              "rmtr_vpa:": viewMoreData?.payerVpa,
              // "rmtr_account_ifsc:": viewMoreData?.rmtrAccountIfsc,
              // "rmtr_account_type:": viewMoreData?.rmtrAccountType,
            }}
            closeModal={() => setShowViewMoreModal(false)}
          />
        </CustomModal1>
      )}
    </div>
  );
}

export default BeneficiaryTransaction;
